export async function getStoredValue(key) {
  const value = localStorage.getItem(key);
  return value ? value : null;
}
